import React from 'react';
import Heading from '../Heading';

const genAIProjectsBySlug = {
  entrepreneurs: [
    {
      title: 'Intelligent Market Research Engine',
      description:
        'Deploy AI agents that automatically research markets, track competitors, and identify opportunities while you focus on building.',
      icon: '/images/GenAI/ProjectOne.png',
    },
    {
      title: 'Customer Intelligence Platform',
      description:
        'Build an AI system that processes all customer interactions and automatically generates insights for product decisions.',
      icon: '/images/GenAI/ProjectTwo.png',
    },
    {
      title: 'AI Business Plan Generator',
      description:
        'Create an intelligent system that transforms ideas into comprehensive business plans with market analysis and financial projections.',
      icon: '/images/GenAI/ProjectThree.png',
    },
    {
      title: 'Automated Investor Outreach System',
      description:
        'Develop AI-powered tools that create personalized investor materials and manage fundraising communications.',
      icon: '/images/GenAI/ProjectFour.png',
    },
    {
      title: 'Growth Experiment AI',
      description:
        'Build intelligent systems that design, execute, and analyze growth experiments across multiple channels.',
      icon: '/images/GenAI/ProjectFive.png',
    },
    {
      title: 'Real-time Business Intelligence Dashboard',
      description:
        'Create AI-powered dashboards that monitor all business metrics and provide predictive insights for decision-making.',
      icon: '/images/GenAI/ProjectSix.png',
    },
  ],
  'product-marketing-management': [
    {
      title: 'Intelligent Competitive Analysis Engine',
      description:
        'Build AI systems that automatically track competitor product updates, pricing changes, and market positioning.',
      icon: '/images/GenAI/ProjectOne.png',
    },
    {
      title: 'Smart User Persona Generator',
      description:
        'Create AI-driven systems that analyze user data to generate detailed, actionable personas with journey maps and pain point analysis.',
      icon: '/images/GenAI/ProjectTwo.png',
    },
    {
      title: 'No-Code AI Product Builder',
      description:
        'Build fully functional product prototypes using AI tools, complete with user authentication and core feature implementation.',
      icon: '/images/GenAI/ProjectThree.png',
    },
    {
      title: 'Automated Product Requirements Generator',
      description:
        'Develop AI systems that transform product ideas into detailed requirements with user stories and technical specifications.',
      icon: '/images/GenAI/ProjectFour.png',
    },
    {
      title: 'Data-Driven Feature Prioritization AI',
      description:
        'Create intelligent feature scoring systems that combine user feedback, market trends, and business metrics for automatic roadmap prioritization.',
      icon: '/images/GenAI/ProjectFive.png',
    },
    {
      title: 'AI-Enhanced Stakeholder Communication Suite',
      description:
        'Build automated reporting systems that transform complex product metrics into compelling executive presentations.',
      icon: '/images/GenAI/ProjectSix.png',
    },
  ],
  marketing: [
    {
      title: 'AI Content Factory',
      description:
        'Create automated content planning systems that generate ideas, create content, and schedule posts across multiple platforms with performance tracking.',
      icon: '/images/GenAI/ProjectOne.png',
    },
    {
      title: 'Smart Audience Intelligence Platform',
      description:
        'Build AI systems that analyze customer data to identify high-value segments and automatically personalize marketing messages for each group.',
      icon: '/images/GenAI/ProjectTwo.png',
    },
    {
      title: 'Campaign Performance AI',
      description:
        'Develop intelligent tools that automatically adjust ad spend, targeting, and creative elements to maximize campaign ROI in real-time.',
      icon: '/images/GenAI/ProjectThree.png',
    },
    {
      title: 'Brand Voice AI Assistant',
      description:
        'Create custom AI writing assistants trained on your brand voice that ensure consistency across all marketing content and channels.',
      icon: '/images/GenAI/ProjectFour.png',
    },
    {
      title: 'Competitive Marketing Intelligence',
      description:
        'Build AI systems that track competitor marketing activities, analyze their strategies, and identify opportunities for differentiation.',
      icon: '/images/GenAI/ProjectFive.png',
    },
    {
      title: 'Customer Journey AI Optimizer',
      description:
        'Develop intelligent tools that map customer touchpoints and automatically optimize experiences throughout the marketing funnel.',
      icon: '/images/GenAI/ProjectSix.png',
    },
  ],
  consulting: [
    {
      title: 'Intelligent Industry Research Engine',
      description:
        'Build comprehensive AI research systems that automatically gather and analyze industry data, trends, and competitive intelligence for client work.',
      icon: '/images/GenAI/ProjectOne.png',
    },
    {
      title: 'Strategy Framework AI Generator',
      description:
        'Create intelligent tools that help develop custom strategic frameworks and recommendations based on client-specific data and industry best practices.',
      icon: '/images/GenAI/ProjectTwo.png',
    },
    {
      title: 'Client Intelligence Dashboard',
      description:
        'Develop AI systems that continuously monitor client industries and provide automated insights and opportunity alerts for proactive advisory.',
      icon: '/images/GenAI/ProjectThree.png',
    },
    {
      title: 'Proposal Automation AI',
      description:
        'Build intelligent proposal generation tools that create customized project scopes and recommendations based on client requirements and historical project data.',
      icon: '/images/GenAI/ProjectFour.png',
    },
    {
      title: 'Knowledge Management AI Platform',
      description:
        'Create AI-powered systems that capture, organize, and make searchable all consulting knowledge, frameworks, and client insights for enhanced delivery.',
      icon: '/images/GenAI/ProjectFive.png',
    },
    {
      title: 'Performance Benchmarking AI',
      description:
        'Develop intelligent benchmarking systems that automatically compare client performance against industry standards and identify improvement opportunities.',
      icon: '/images/GenAI/ProjectSix.png',
    },
  ],
  'design-ui-ux': [
    {
      title: 'AI Design System Builder',
      description:
        'Create comprehensive design systems with AI-generated components, automated documentation, and intelligent usage guidelines for consistent product design.',
      icon: '/images/GenAI/ProjectOne.png',
    },
    {
      title: 'User Feedback Analysis AI',
      description:
        'Build intelligent systems that automatically analyze user feedback, usability tests, and support tickets to identify design improvement opportunities.',
      icon: '/images/GenAI/ProjectTwo.png',
    },
    {
      title: 'Design Variation Generator',
      description:
        'Develop AI tools that create multiple design variations for A/B testing and optimization based on design principles and user behavior data.',
      icon: '/images/GenAI/ProjectThree.png',
    },
    {
      title: 'Accessibility AI Auditor',
      description:
        'Create automated systems that check designs for accessibility compliance and provide specific, actionable improvement recommendations.',
      icon: '/images/GenAI/ProjectFour.png',
    },
    {
      title: 'Competitive Design Intelligence',
      description:
        'Build AI tools that track competitor design patterns, identify emerging trends, and suggest opportunities for design differentiation.',
      icon: '/images/GenAI/ProjectFive.png',
    },
    {
      title: 'Smart Prototyping AI Assistant',
      description:
        'Develop intelligent prototyping tools that generate interactive prototypes from design mockups and user flow descriptions automatically.',
      icon: '/images/GenAI/ProjectSix.png',
    },
  ],
  operations: [
    {
      title: 'Process Automation AI Suite',
      description:
        'Build comprehensive automation systems that handle repetitive operational tasks and provide intelligent workflow optimization recommendations.',
      icon: '/images/GenAI/ProjectOne.png',
    },
    {
      title: 'Predictive Maintenance AI',
      description:
        'Create intelligent systems that predict equipment failures, automatically schedule maintenance, and optimize resource allocation based on usage patterns.',
      icon: '/images/GenAI/ProjectTwo.png',
    },
    {
      title: 'Performance Monitoring AI Dashboard',
      description:
        'Develop real-time operations dashboards that track KPIs, automatically identify bottlenecks, and suggest process improvements using AI analysis.',
      icon: '/images/GenAI/ProjectThree.png',
    },
    {
      title: 'Resource Optimization AI',
      description:
        'Build intelligent systems that optimize staffing, inventory, and resource allocation based on AI-powered demand forecasting and historical data analysis.',
      icon: '/images/GenAI/ProjectFour.png',
    },
    {
      title: 'Quality Management AI',
      description:
        'Create automated quality control systems that monitor processes, identify issues using AI pattern recognition, and ensure consistent standards.',
      icon: '/images/GenAI/ProjectFive.png',
    },
    {
      title: 'Operational Risk AI Analyzer',
      description:
        'Develop intelligent tools that identify potential operational risks, assess their impact using predictive models, and provide automated mitigation strategies.',
      icon: '/images/GenAI/ProjectSix.png',
    },
  ],
};

const ProjectsYoullBuild = ({ slug }) => {
  const projects = genAIProjectsBySlug?.[slug];

  return (
    <div className="rounded-xl bg-[#E7F7F6] px-6 py-8">
      <Heading>Projects You'll Build</Heading>
      <div className="grid gap-6 md:grid-cols-2">
        {projects.map((project, idx) => (
          <div key={idx} className="flex gap-4">
            <img
              src={project.icon}
              alt={project.title}
              className="h-[60px] w-[60px] md:h-[110px] md:w-[110px]"
            />
            <div>
              <h3 className="text-lg font-semibold text-black">
                {project.title}
              </h3>
              <p className="mt-1 text-sm text-gray-700">
                {project.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProjectsYoullBuild;
